import React from 'react'

export const SliderTimeContext = React.createContext()
